import { createAuthorColumn, createPostColumn, createPublishedInColumnForContent, createTrashedAtColumn } from './Columns'
import { getTrashedContent } from './service'
import {
  Restore,
  PermanentlyDelete,
  EmptyTrash
} from './BulkActions'
/* eslint-disable import/no-internal-modules */
import Overview from '@insided/deprecated-control/overview'
import EmptyPage from '@insided/deprecated-preact-components/empty-page/EmptyPage'
import globals from '@insided/deprecated-utils/globals'

const TrashCanOverview = () => {
  const COLUMNS = [
    createPostColumn(),
    createPublishedInColumnForContent(),
    createAuthorColumn(),
    createTrashedAtColumn()
  ]
  const BULK_ACTIONS = [Restore, PermanentlyDelete]

  return (
    <Overview
      type='trash-can'
      headerTitle='Trash Can'
      withPagination={{
        page: 1,
        pageSize: 25
      }}
      rowId='key'
      model={COLUMNS}
      dataSource={getTrashedContent}
      entity='posts'
      bulkActions={BULK_ACTIONS}
      headerButtons={[<EmptyTrash key='empty-trash' />]}
      EmptyStateComponent={
        <EmptyPage
          img_src={`${globals('basePath')}images/empty_trash_can.png`}
          header='The trash can is empty'
          text='When you trash a topic, it will be shown here.'
          button={{ link: '/overview', text: 'Go back to overview' }}
        />
      }
    />
  )
}

export default TrashCanOverview
